module.exports = __webpack_public_path__ + "img/ship.3dc2a759.png";